<a
  class="c-download-link"
  *ngIf="file"
  (click)="download()">
  <fa-icon [icon]="faDownload"></fa-icon>
  {{ file.fileName }}
</a>
